import React from 'react';
import { Flex, Button, Popconfirm } from 'antd';

const AssessmentActions = ({
  proAssess,
  approvedPro,
  cancelledPro,
  pendingPro = [],
  canApprove,
  canDecline,
  canMarkPending,
  markProductPending,
  assessment,
  openAssessmentActionModal,
  // For the main actions panel
  allProductsProcessed,
  allProductsMarkedPending,
  handleSubmit,
  isSubmit,
  canRefund,
  handleSubmitPending,
  isMarkPending,
  handleCancelRefund,
  isCancelRefund,
  order,
  cancelledPro: allCancelledPro,
  approvedPro: allApprovedPro
}) => {
  // For individual product actions
  if (proAssess) {
    const productId = String(proAssess.productId ?? "");
    const approvedIds = approvedPro.map((id) => String(id));
    const cancelledIds = cancelledPro.map((id) => String(id));
    const pendingIds = pendingPro.map((id) => String(id));
    const alreadyMarked =
      approvedIds.includes(productId) ||
      cancelledIds.includes(productId) ||
      pendingIds.includes(productId);

    return (
      <>
        <hr />
        <div className="col-12 text-end mt-2">
          <Flex wrap gap="small">
            {canDecline && (
              <button
                className="btn btn-sm btn-danger"
                disabled={alreadyMarked}
                onClick={() => openAssessmentActionModal(productId, 'cancel')}
              >
                {cancelledIds.includes(productId)
                  ? "X Declined"
                  : "X Decline"}
              </button>
            )}
            {canApprove && (
              <button
                className="btn btn-sm btn-primary"
                disabled={alreadyMarked}
                onClick={() => openAssessmentActionModal(productId, 'approve')}
                >
                {approvedIds.includes(productId)
                  ? "✓ Approved"
                  : "✓ Approve"}
              </button>
            )}
            {canMarkPending &&
              (order?.status === "ASSESSMENT_REQUIRED" || order?.status === "TO_CANCEL") &&
              assessment?.status === "PENDING" && (
              <button
                className="btn btn-sm btn-warning"
                disabled={alreadyMarked}
                onClick={() => markProductPending(productId)}
              >
                {pendingIds.includes(productId)
                  ? "Marked Pending"
                  : "Mark as Pending"}
              </button>
            )}
          </Flex>
        </div>
      </>
    );
  }

  // For the main submit actions
  return (
    <>
      {allProductsMarkedPending && canMarkPending && (
        <div className="text-center mt-4">
          <Button
            type="primary"
            onClick={handleSubmitPending}
            disabled={isMarkPending}
          >
            {isMarkPending && <i className="fa fa-spinner fa-spin"></i>}
            Submit Pending Products
          </Button>
        </div>
      )}

      {allProductsProcessed && (
        <>
        <div className="text-center mt-4">
          <Button
              type="primary"
              onClick={handleSubmit}
              disabled={isSubmit}
          >
              {isSubmit && <i className="fa fa-spinner fa-spin"></i>}
              Submit Approved/Cancelled Products
          </Button>
        </div>

        {order.platform === "Ebay" &&
          allCancelledPro.length > 0 &&
          allApprovedPro.length === 0 &&
          canRefund && (
            <div className="text-center mt-4">
              <Button
                danger
                onClick={handleCancelRefund}
                disabled={isCancelRefund}
              >
                {isCancelRefund && <i className="fa fa-spinner fa-spin"></i>}
                Order Cancel & Refund
              </Button>
            </div>
          )}
          </>
      )}


    </>
  );
};

export default AssessmentActions;